import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=5d62b026&scoped=true"
var script = {}
import style0 from "./ExchangeRate.vue?vue&type=style&index=0&id=5d62b026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d62b026",
  null
  
)

export default component.exports